import CourseRegistrationSubheader from './CourseRegistrationSubheader';
import { CourseRegistrationSubheaderProps, CourseRegistrationSubheaderValueProps } from './types';

export type { CourseRegistrationSubheaderProps, CourseRegistrationSubheaderValueProps };
export default CourseRegistrationSubheader;
